/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';
import template from './context-service-configuration-list-page.component.html';
import {APP_SHARED} from '../../common/app-shared';
import {SignalAdminResourceListComponent} from '../../common/controller/signal-admin-resource-list.component';
import {
  SignalAdminListColumn,
  SignalAdminResourceListStateFactory
} from '../../common/controller/signal-admin-resource-list-state';
import {
  ContextServiceConfigurationApiService,
  ContextServiceConfigurationModel
} from './context-service-configuration-api.service';

@Component({
  standalone: true,
  selector: 'adn-context-service-configuration-list-page',
  imports: [...APP_SHARED, UIRouterModule, SignalAdminResourceListComponent],
  template
})
export class ContextServiceConfigurationListPageComponent implements OnInit {
  readonly itemStateName = 'app.adm.context-service-configurations.context-service-configuration';

  readonly columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: 'contextService'},
    {param: 'username'},
    {param: 'apiKey'}
  ];
  readonly list = inject(SignalAdminResourceListStateFactory).create<ContextServiceConfigurationModel>(
    inject(ContextServiceConfigurationApiService),
    {listId: 'fullContextServiceConfigurationList'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }
}
